module.exports = __webpack_public_path__ + "img/mano_water.407e59c5.png";